<template id="emoji-picker">
  <div>
    <div class="emoji-invoker" @click="handleVisible">
      <font-awesome-icon
        size="2x"
        class="cp"
        :style="{
          color: customColor || getPrimaryColor(),
          transform: 'scale(0.9)',
          margin: '0 5px',
        }"
        :icon="['fal', 'smile']"
      />
    </div>

    <div
      v-if="visible"
      class="emoji-picker"
      :style="{
        position: 'absolute',
      }"
    >
      <!-- <div class="close-icon">
        <a-icon @click="handleVisible" type="close-circle" theme="filled" />
      </div> -->
      <!-- <div class="emoji-picker__search">
        <input
          type="text"
          v-model="search"
          ref="search"
          class="emoji-picker__search-input"
        />
      </div> -->
      <div>
        <div :key="category" v-for="(emojis, category) in this.searchedEmojis">
          <h5>{{ category }}</h5>
          <div>
            <span
              class="emojis"
              :style="{ cursor: 'pointer', 'font-size': '25px' }"
              v-for="(emoji, emojiName) in emojis"
              @click="
                () => {
                  insert(emoji)
                  handleVisible
                }
              "
              :title="emojiName"
              :key="emojiName"
              >{{ emoji }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "emojiPicker",
  props: {
    visible: Boolean,
    insert: Function,
    handleVisible: Function,
    customColor: String,
  },
  data() {
    return {
      emojis: {
        Smiley: {
          grinning: "😀",
          smiley: "😃",
          smile: "😄",
          blush: "😁",
          squintingFace: "😆",
          grindingSweat: "😅",
          rollingOnFloorLaughing: "🤣",
          face_with_tears_joy: "😂",
          straightSmilyFace: "🙂",
          upSideDownFace: "🙃",
          winkFace: "😉",
          smilyFace: "😊",
          smilyHalo: "😇",
          faceHearts: "🥰",
          heart_eyes: "😍",
          star_eyes: "🤩",
          blowingKiss: "😘",
          kissingFace: "😗",
          smilingFace: "☺",

          tounge_eyes: "😋",
          toungeFace: "😛",
          winkFaceTounge: "😜",
          hugFace: "🤗",
          faceWithHandsMouth: "🤭",
          thinkingFace: "🤔",
          eyebrowRaised: "🤨",
          neutral_face: "😐",
          faceWithoutMouth: "😶",
          smirkFace: "😏",
          unAmused: "😒",
          eyeRollingFAce: "🙄",
          sleepyFacezzz: "😴",
          sleepyFace: "😪",
          pensiveFace: "😔",
          relivedFace: "😌",
          grimanceFace: "😬",
          coolSmile: "😎",
          partyFace: "🥳",
          woozyFace: "🥴",
          coldFace: "🥶",
          hotFace: "🥵",
          sneezingFace: "🤧",
          nauseatedFace: "🤢",
          faceWithHeadBandage: "🤕",
          thermometerFace: "🤒",
          maskFace: "😷",
          poutAngry: "😡",
          angry: "😠",
          angryFace: "😤",
          yawnFace: "🥱",
          sob: "😭",
          anxious: "😰",
          angushied: "😧",
          astonished: "😲",
          hushed: "😯",
          openMouth: "😮",
          frowning: "☹",
          forwningFace: "🙁",
          worried: "😟",
          monocleFace: "🧐",
          nerdFace: "🤓",
          confused: "😕",

          blush: "😊",
        },
        Gestures: {
          waving: "👋",
          stop: "🤚",
          hi: "🖐",
          vulcanSalute: "🖖",
          okHand: "👌",
          victory: "✌",
          croosedFingers: "🤞",
          loveYou: "🤟",
          signOfPartial: "🤘",
          callMe: "🤙",
          pointLeft: "👈",
          pointRight: "👉",
          pointUp: "👆",
          pointDown: "👇",
          indexUp: "☝",
          thumbs_up: "👍",
          thumbsDown: "👎",
          fist: "✊",
          claping: "👏",
          palmTOgether: "🤲",
          handShake: "🤝",
          writingHands: "✍",
          biceps: "💪",
        },
        Others: {
          brokenHeart: "💔",
          redHeart: "❤",
          towHearts: "💕",
          glowingHearts: "💗",
        },
      },
      search: "",
      display: {
        x: 0,
        y: 0,
        visible: false,
      },
    }
  },
  watch: {
    visible: function(newval, old) {
      console.log(newval, old, "asdvinay")
    },
  },
  computed: {
    searchedEmojis() {
      if (this.search) {
        const obj = {}

        for (const category in this.emojis) {
          obj[category] = {}

          for (const emoji in this.emojis[category]) {
            if (new RegExp(`.*${this.search}.*`).test(emoji)) {
              obj[category][emoji] = this.emojis[category][emoji]
            }
          }
        }

        return obj
      }

      return this.emojis
    },
  },
  methods: {
    toggle(e) {
      this.display.visible = !this.display.visible
      this.display.x = e.clientX
      this.display.y = e.clientY
      if (this.visible) this.$nextTick(() => this.$refs.search.focus())
    },
  },
}
</script>

<style lang="scss" scoped>
.emoji-picker {
  position: absolute;
  z-index: 200;
  font-family: Montserrat;
  border: 1px solid #ccc;
  height: 16rem;
  overflow: auto;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
  left: 3px;
  bottom: 70px;
  max-width: 200px;
  @media screen and (max-width: 600px) {
    max-width: unset;
    width: 87vw;
  }

  &__search-input {
    height: 30px;
  }
}
.emoji {
  cursor: pointer;
}

.close-icon {
  display: flex;
  justify-content: flex-end;
  width: 100%;

  padding-bottom: 10px;
  margin-left: 12px;
  margin-top: -12px;

  i {
    color: rgb(223, 73, 73);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/emojiPicker.vue